import './App.scss';
import SelectionPage from "./SelectionPage";

function App() {
  return (
    <div className="app">
      <SelectionPage />
    </div>
  );
}

export default App;
